import { render, staticRenderFns } from "./ContractStatusBadge.vue?vue&type=template&id=3f1acc0d"
import script from "./ContractStatusBadge.vue?vue&type=script&lang=js"
export * from "./ContractStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports